import React, { useState } from 'react'
import './styles.scss'
import { getStaticImage } from 'utils/statics'
import { I18n } from 'react-redux-i18n'
import { SelectWithLabel } from 'components/Form'
import { useEffect } from 'react'

const Header = (props) => {

  const {
    setOpen,
    markAsRead,
    dispatch,
    dashNotificationAct,
    filters
  } = props

  const readOrNotOptions = [
    {
      label: I18n.t('dashboard_read'),
      value: 'read',
    },
    {
      label: I18n.t('dashboard_unread'),
      value: 'unread',
    }
  ]
  const [filterRead, setFilterRead] = useState([])
  const typesOptions = [
    // {
    //   label: I18n.t('dash_noti_option_mention'),
    //   value: 'mention',
    // },
    {
      label: I18n.t('dashboard_assigned-plural'),
      value: 'assign',
    },
    {
      label: I18n.t('dashboard_smartchat'),
      value: 'smartchat',
    },
    {
      label: I18n.t('dashboard_export'),
      value: 'export',
    },
    {
      label: I18n.t('dashboard_export-error'),
      value: 'exportError',
    }
  ]
  const [filterType, setFilterType] = useState([])

  useEffect(() => {
    verifyDisplay()
    verifyType()
  }, [])

  const verifyDisplay = () => {
    if(filters.display !== 'all'){
      const value = readOrNotOptions.filter(read => read.value === filters.display)
      setFilterRead(value)
    }else{
      setFilterRead(readOrNotOptions)
    }
  }

  const verifyType = () => {
    const filtersType = []
    filters.type.forEach(type => {
      const filter = typesOptions.find(typeValue => typeValue.value === type)
      filtersType.push(filter)
    })
    setFilterType(filtersType)
  }

  const changeValue = (type='read'|'type', values) => {
    if(type==='read') {
      if(values.length === 0) return
      let display = 'all'
      if(values.length === 1){
        display = values[0].value === 'read'? 'read' : 'unread'
      }
      setFilterRead(values)
      dispatch(dashNotificationAct.updateFilters({ ...filters, display, page: 0 }, false))
      return
    }
    let types = []
    setFilterType(values)
    values.forEach(value => {
      types.push(value.value)
    })

    dispatch(dashNotificationAct.updateFilters({ ...filters, type: types, page: 0 }, false))
  }

  return (
    <div className='header-container'>
      <div className='close-wrapper'>
        <label className='text-readAll' onClick={() => markAsRead('all', true)}>{I18n.t('dashboard_mark_all_as_read')}</label>
        <img onClick={() => setOpen(false)} src={getStaticImage('/icons/orange-brand/icon-close.svg')}  alt={'Close'}/>
      </div>
      <div className='close-wrapper' style={{ padding: '10px 0' }}>
        <SelectWithLabel
          multi
          isRequiredAll
          placeholder={I18n.t('dashboard_types')}
          options={typesOptions}
          value={filterType}
          selectedValues={filterType}
          onChange={(value) => changeValue('type', value)}
          classNameWrapper={'dash-notifications-filters sizeType'}
          labelWithSelected={filterType.length === typesOptions.length && I18n.t('dashboard_all_types')}
          labelCustomSelected={I18n.t('dashboard_types')}
        />
        <SelectWithLabel
          multi
          labelWithSelected={filterRead.length === readOrNotOptions.length && I18n.t('dashboard_read-and-unread')}
          value={filterRead}
          options={readOrNotOptions}
          onChange={(value) => changeValue('read', value)}
          classNameWrapper={'dash-notifications-filters sizeRead'}
        />
      </div>
    </div>
  )
}

export default Header